/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EFinancialOrderLogType } from "../types/EFinancialOrderLogType.ts";

/**
 * @description 0 = Undefined | 1 = CreditCardCreationTreasuryStudent | 2 = CreditCardLimitTreasuryStudent | 3 = CreditCardLimitIndividualPaymnent | 4 = CreditCardLimitEnrollment | 5 = BilletEnrollment | 6 = BilletTreasuryStudent | 7 = BilletIndividualPaymnent | 8 = BilletWebhookReturn | 9 = CreditCardWebhookReturn | 10 = CreditCardRecurrence |
 */
export const eFinancialOrderLogTypeSchema = z
  .union([
    z.literal(0),
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
  ])
  .describe(
    "0 = Undefined | 1 = CreditCardCreationTreasuryStudent | 2 = CreditCardLimitTreasuryStudent | 3 = CreditCardLimitIndividualPaymnent | 4 = CreditCardLimitEnrollment | 5 = BilletEnrollment | 6 = BilletTreasuryStudent | 7 = BilletIndividualPaymnent | 8 = BilletWebhookReturn | 9 = CreditCardWebhookReturn | 10 = CreditCardRecurrence | ",
  ) as unknown as ToZod<EFinancialOrderLogType>;
